import { style } from 'typestyle';
import { resetButton } from '../theme/reset';
import { flexRoot, centerCenter } from 'csstips';
import { px } from 'csx';
import { rebrand } from '../theme/color';
import { BASE_LINE_HEIGHT } from '../constants';
import { borderRadius } from '../theme/border';
import { spacing } from '../theme/spacing';

export const tooltipStyles = {
  tooltip: style({
    maxWidth: px(420),
    minHeight: px(32), // To account for size of close button
    lineHeight: BASE_LINE_HEIGHT,
    padding: `${spacing.XSMALL} ${spacing.XLARGE} ${spacing.XSMALL} ${spacing.SMALL}`, // Extra padding-right to account for close button
  }),
  tooltipInner: style({
    display: 'block',
  }),
  tooltipCloseBtn: style(resetButton, flexRoot, centerCenter, {
    position: 'absolute',
    display: 'block',
    lineHeight: 1,
    top: 0,
    right: 0,
    width: px(32),
    height: px(32),
    color: rebrand.contrast[50].toHexString(),
  }),
  tooltipBtn: style(resetButton, {
    color: 'inherit',
    textAlign: 'left',
    $nest: {
      '&.center': {
        textAlign: 'center',
      },
    },
  }),
};
